// extracted by mini-css-extract-plugin
export default {"blockPadding":"25px","blockBorderRadius":"0.25rem","inspector":"Inspector_inspector__VhFxC"};